import { FC } from "react";
import { brand } from "@/brandVariables/getBandVariables";
import { useTimer } from "@/hooks/useCountDown";
import { ClientProps } from "@/hooks/useClientData";
import { TimerComp } from "../TimerComp";
import { WinnerCard } from "../WinnerCard";
import prizeBox from "../../assets/logitech/10330_alt6.webp";

export const Logitech_custom_Racing_meta: FC<{
  clientData: ClientProps;
}> = ({ clientData }) => {
  const { time } = useTimer(clientData.challenge.data?.endDate || undefined);

  const isElgiganten = brand.client === "elgiganten-9u2oj" ? "text-gradient" : "";

  return (
    <div className="meta">
      <div className="meta__timer">
        <TimerComp time={time} />
      </div>

      <div className="meta__map">
        <div>
          <p>Prize:</p>
          <h2>MCLAREN MP4/4</h2>
        </div>
        <div>
          <img src={prizeBox} alt="" />
        </div>
      </div>

      {clientData.winners.data.length !== 0 && (
        <div className={`meta__winner`}>
          <div className={`winner__banner ${isElgiganten}`}>
            <p>previous winner</p>
          </div>
          <WinnerCard clientData={clientData} hasBanner={false} />
        </div>
      )}
    </div>
  );
};
